import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';

/** What the signed-in user may do on a driver's page; the server decides, this only hides what would be refused. */
export function useDriverPermissions() {
  const { state } = useCurrentUser();
  const permissions = state.status === 'authenticated' ? state.user.permissions : [];
  return {
    canManage: permissions.includes('driver.manage'),
    canManageDevices: permissions.includes('driver.device.manage'),
    canViewLedger: permissions.includes('driver_ledger.view'),
    canRecordLedger: permissions.includes('driver_ledger.record'),
    canExportPayroll: permissions.includes('payroll.export'),
  };
}
